<div class="flex flex-col h-[450px] w-[600px] p-4 overflow-hidden">
  <div class="flex flex-row items-center">
    <img class="w-10 h-10 mr-2" src="assets/icons/ai-shine-stars.svg" alt="AI Ability" />
    <h3>Inform Ethan what type of calculation you would like to do.</h3>
  </div>
  <form class="flex flex-col h-full w-full" [formGroup]="form">
    <mat-form-field appearance="fill">
      <mat-label>Field Label</mat-label>
      <input matInput id="fieldLabel" type="text" formControlName="fieldLabel" />
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Ask for a calc code</mat-label>
      <textarea
        matInput
        id="askForCalcCodeInput"
        type="text"
        formControlName="askForCalcCodeInput"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="invokeAbility()"
      ></textarea>
      <button mat-button matSuffix mat-icon-button (click)="invokeAbility()">
        <mat-icon *ngIf="!ui.loading">send</mat-icon>
        <mat-spinner *ngIf="ui.loading" diameter="20"></mat-spinner>
      </button>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Ethan response</mat-label>
      <textarea class="font-mono" matInput id="ethanResponse" type="text" formControlName="ethanResponse"></textarea>
    </mat-form-field>
  </form>
  <div class="flex flex-row justify-end">
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button color="primary" (click)="useCode()" [disabled]="form.invalid">Use code</button>
  </div>
</div>
